import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import SearchPicker from "@/components/SearchPicker";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { formatVariantLabel, sortVariants } from "@/lib/variants";

// Satın alma satırında hazır ticari ürün + beden/varyant seçimi
export function PurchaseProductPicker({ index, line, onChange }) {
  const [product, setProduct] = useState(line.material_id ? { id: line.material_id, name: line.product_name } : null);
  const [variants, setVariants] = useState([]);
  const lastResults = useRef([]);
  useEffect(() => {
    if (!line.material_id) { setVariants([]); return; }
    api.get(`/products/${line.material_id}/variants`).then(({ data }) => {
      setVariants(sortVariants(data || []));
      const cur = (data || []).find((v) => v.id === line.variant_id);
      onChange({ has_variants: (data || []).length > 0, ...(cur ? { variant_sku: cur.sku || "" } : {}) });
    }).catch(() => setVariants([]));
  }, [line.material_id]); // eslint-disable-line react-hooks/exhaustive-deps
  const pick = (pid) => {
    const p = pid ? lastResults.current.find((x) => x.id === pid) || product : null;
    setProduct(p);
    onChange({ material_id: pid || "", product_name: p?.name || "", variant_id: "", variant_sku: "" });
  };
  return (
    <div className="grid grid-cols-1 gap-1.5">
      <SearchPicker
        testId={`purchase-line-${index}-product`}
        items={product ? [product] : []}
        value={product?.id || ""}
        selectedItem={product || undefined}
        onChange={pick}
        onSearch={async (q) => {
          try {
            const { data } = await api.get("/products", { params: { search: q, limit: 200 } });
            lastResults.current = Array.isArray(data) ? data : [];
            return lastResults.current;
          } catch { return []; }
        }}
        getLabel={(p) => p.name || ""}
        getSubtitle={(p) => [p.brand, p.code].filter(Boolean).join(" · ")}
        placeholder="Ürün ara — en az 2 harf…"
        minChars={2}
      />
      <Select value={line.variant_id || ""} disabled={!variants.length}
        onValueChange={(vid) => onChange({ variant_id: vid, variant_sku: variants.find((v) => v.id === vid)?.sku || "" })}>
        <SelectTrigger data-testid={`purchase-line-${index}-variant`} className="bg-slate-950 border-slate-700 rounded-sm h-9 text-xs">
          <SelectValue placeholder={variants.length ? "Beden" : "Beden yok"} />
        </SelectTrigger>
        <SelectContent className="bg-slate-900 border-slate-800 text-slate-100 rounded-sm">
          {variants.map((v) => <SelectItem key={v.id} value={v.id}>{formatVariantLabel(v.attributes, v.sku)}</SelectItem>)}
        </SelectContent>
      </Select>
      {line.stock_hint && <div className="text-[10px] font-mono text-slate-500" data-testid={`purchase-line-${index}-stock-hint`}>{line.stock_hint}</div>}
    </div>
  );
}
